import { render, staticRenderFns } from "./permitidos.vue?vue&type=template&id=28320ad0&"
import script from "./permitidos.vue?vue&type=script&lang=js&"
export * from "./permitidos.vue?vue&type=script&lang=js&"
import style0 from "./permitidos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports